"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CellBPKeywords = function CellBPKeywords(props) {
  var type = props.type,
      header = props.header,
      headerText = props.headerText,
      width = props.width,
      sortable = props.sortable,
      sortOrder = props.sortOrder,
      stats = props.stats,
      allowMultiline = props.allowMultiline;
  var _props$data = props.data,
      keyword_tags = _props$data.keyword_tags,
      top_keyword_tags = _props$data.top_keyword_tags;
  var keywords = keyword_tags || top_keyword_tags;

  if (!header && !keywords && !keywords.length) {
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
      width: width
    }, "-");
  }

  var headerContent = headerText || type;
  return header ? /*#__PURE__*/_react["default"].createElement(_styled.StyledHeaderCell, {
    width: width,
    sortable: sortable,
    sortOrder: sortOrder
  }, headerContent) : /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
    padding: "0",
    width: width,
    height: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_styled.KeywordsContainer, {
    allowMultiline: allowMultiline,
    stats: stats
  }, keywords.map(function (kw, idx) {
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledKeyword, _extends({
      allowMultiline: allowMultiline,
      key: "keyword-cell-".concat(kw.value, "-").concat(idx)
    }, kw), kw.value);
  })));
};

var _default = CellBPKeywords;
exports["default"] = _default;

//# sourceMappingURL=CellBPKeywords.js.map